module.exports = __webpack_public_path__ + "static/media/recievables.7e2b16cd.svg";